import { Button, Tooltip } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
	Card,
	CardBody,
	CardHeader,
} from '../../../../_metronic/_partials/controls'
import { getLegales } from '../../../../api/legal'
import { alertError } from '../../../../utils/logger'
import Table, { buttonsStyle } from '../../../components/tables/table'

/**
 * Los textos legales de sailradar.com: cuatro documentos por tres idiomas.
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ AQUÍ SOLO SE EDITA. NO SE CREA NI SE BORRA                               │
 * │                                                                          │
 * │ La lista enseña siempre los DOCE que tiene que haber, existan o no en la │
 * │ base todavía: así se ve de un vistazo cuál está sin escribir en vez de   │
 * │ tener que acordarse de que falta. Guardar uno vacío lo crea.             │
 * │                                                                          │
 * │ No hay botón de borrar porque el pie de la web enlaza a estas páginas:   │
 * │ borrar una es dejar un enlace roto a la política que el sitio dice tener.│
 * │ Para quitar una del público basta con despublicarla.                     │
 * └──────────────────────────────────────────────────────────────────────────┘
 */

const IDIOMAS = { es: 'Castellano', ca: 'Català', en: 'English' }

/** Los tramos de la dirección pública, para poder ir a verla. */
const TRAMOS = {
	es: { legal: 'legal', 'aviso-legal': 'aviso-legal', privacidad: 'privacidad', cookies: 'cookies', condiciones: 'condiciones' },
	ca: { legal: 'legal', 'aviso-legal': 'avis-legal', privacidad: 'privacitat', cookies: 'galetes', condiciones: 'condicions' },
	en: { legal: 'legal', 'aviso-legal': 'legal-notice', privacidad: 'privacy', cookies: 'cookies', condiciones: 'terms' },
}

const direccionPublica = (clave, idioma) => {
	const t = TRAMOS[idioma]
	const prefijo = idioma === 'es' ? '' : `/${idioma}`
	return `https://sailradar.com${prefijo}/${t.legal}/${t[clave]}/`
}

const fecha = (d) => (d ? new Date(d).toLocaleDateString('es-ES') : '—')

export default function LegalPage() {
	const [data, setData] = useState([])
	const history = useHistory()

	useEffect(() => {
		getLegales()
			.then((res) => {
				if (res.status === 200)
					setData(
						res.data.map((d) => ({
							...d,
							id: `${d.clave}|${d.idioma}`,
							idiomaTexto: IDIOMAS[d.idioma] ?? d.idioma,
							estado: d,
							actualizado: d.updatedAt,
							acciones: d,
						}))
					)
			})
			.catch((error) => alertError({ error, customMessage: 'No se pudieron cargar los textos legales.' }))
	}, [])

	/**
	 * Tres estados y no dos: «sin escribir» es distinto de «en borrador».
	 * Uno hay que redactarlo y el otro solo hay que revisarlo y encenderlo.
	 */
	function estadoFormatter(d) {
		if (d.vacio)
			return <span style={{ color: '#c0392b', fontWeight: 600 }}>sin escribir</span>
		if (!d.publicado)
			return <span style={{ color: '#8a6d1b', fontWeight: 600 }}>borrador</span>
		return <span style={{ color: '#1b8a5a', fontWeight: 600 }}>publicado</span>
	}

	function accionesFormatter(d) {
		return (
			<>
				<Tooltip title="Editar el texto">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push(`/edit-legal/${d.clave}/${d.idioma}`)}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{d.publicado && !d.vacio && (
					<Tooltip title="Ver la página publicada">
						<Button
							style={buttonsStyle}
							size="small"
							onClick={() => window.open(direccionPublica(d.clave, d.idioma), '_blank', 'noopener')}
						>
							<OpenInNewIcon />
						</Button>
					</Tooltip>
				)}
			</>
		)
	}

	const columns = [
		{ dataField: 'nombre', text: 'Documento', sort: true },
		{ dataField: 'idiomaTexto', text: 'Idioma', sort: true },
		{ dataField: 'titulo', text: 'Título en la página' },
		{ dataField: 'estado', text: 'Estado', formatter: estadoFormatter },
		{ dataField: 'actualizado', text: 'Actualizado', formatter: fecha, sort: true },
		{
			dataField: 'acciones',
			text: '',
			formatter: accionesFormatter,
			align: 'end',
			style: { whiteSpace: 'nowrap' },
		},
	]

	return (
		<Card>
			<CardHeader title="Textos legales" />
			<CardBody>
				<p style={{ color: '#7b8794', marginBottom: 16 }}>
					Lo que se publica en sailradar.com. Un documento <strong>solo sale al público cuando se
					publica</strong>: mientras esté en borrador, su dirección contesta como si no existiera. No se
					pueden crear ni borrar documentos — son estos cuatro, en tres idiomas.
				</p>
				<Table data={data} columns={columns} />
			</CardBody>
		</Card>
	)
}
